import styled from 'styled-components'

export const Container = styled.ol`
	margin: 0;
	padding: 0;
	list-style: none;
`
